import { hasPermission } from '@/hooks/useBackendMenu'
import { StatusAprovacao } from '@acme/core'
import dayjs from 'dayjs'
import Dialog from 'global/guides/Dialog'
import { useParams } from 'react-router-dom'
import FormDetalhesAfastamento from '../forms/DetalhesAfastamento'
import { useDigitacaoDataContext } from '../pages/useDigitacaoData'
import useService from '../service'
import { funcionarioPodeSolicitarAjustes } from './DetalhesRegistros'

export function DetalhesAfastamento() {
    const { id } = useParams()
    const {
        context: { data },
    } = useDigitacaoDataContext()
    const {
        handleAprovar,
        handleExcluir,
        handleReprovar,
        handleAtualizarAfastamento,
    } = useService()
    const afastamento = data?.find(
        ({ afastamento }) => afastamento?.id === Number(id),
    )?.afastamento

    const funcionarioPodeAjustar = funcionarioPodeSolicitarAjustes()

    if (!afastamento) return null

    return (
        <Dialog.Root
            disableFields={!hasPermission(['update', 'Afastamentos'])}
            defaultValues={{
                ...afastamento,
                dias:
                    dayjs(afastamento?.dataFinal).diff(
                        afastamento?.dataInicial,
                        'day',
                    ) + 1,
            }}
            onDelete={
                hasPermission(['delete', 'Afastamentos']) ||
                funcionarioPodeAjustar
                    ? ({ motivo }) =>
                          handleExcluir('AFASTAMENTO', {
                              ...afastamento,
                              motivo,
                          })
                    : undefined
            }
            validateOnDelete={
                afastamento?.statusAprovacao != StatusAprovacao.PENDENTE
            }
            height="auto"
            onSubmit={
                hasPermission(['update', 'Afastamentos'])
                    ? handleAtualizarAfastamento
                    : undefined
            }
        >
            <Dialog.Title>Detalhes do afastamento</Dialog.Title>
            <Dialog.Content dividers>
                <FormDetalhesAfastamento />
                <Dialog.Content.Footer
                    onApprove={
                        hasPermission(['update', 'Afastamentos'])
                            ? () => handleAprovar('AFASTAMENTO', afastamento)
                            : undefined
                    }
                    onReject={
                        hasPermission(['update', 'Afastamentos'])
                            ? ({ motivo }) =>
                                  handleReprovar('AFASTAMENTO', {
                                      id: afastamento.id,
                                      motivo,
                                  })
                            : undefined
                    }
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}
